import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FP } from "./tokens";

/**
 * Barra superior con "Volver" para envolver, dentro de un Dialog fullScreen,
 * pantallas existentes que no tienen modo embebido propio.
 */
export default function BarraVolver({ onExit }) {
  return (
    <Box
      sx={{
        px: 2,
        py: 1.2,
        borderBottom: `1px solid ${FP.color.border}`,
        bgcolor: "#FFFFFF",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={onExit}
        sx={{
          textTransform: "none",
          fontWeight: 700,
          color: FP.color.navy,
          border: `1px solid ${FP.color.navy}`,
          borderRadius: 1.8,
        }}
      >
        Volver
      </Button>
    </Box>
  );
}
